{
  "home": "Home",
  "projects": "Projects",
  "my_tasks": "My tasks",
  "meetings": "Meetings",
  "transcripts": "Transcripts",
  "reports": "Reports",
  "portfolio": "Portfolio",
  "billing": "Plans & billing",
  "settings": "Settings",
  "members": "Members",
  "departments": "Teams",
  "menu": "Menu",
  "bottom_nav": "Primary navigation",
  "search_placeholder": "Search…",
  "search": {
    "searching": "Searching…",
    "no_results_prefix": "No results for",
    "groups": {
      "projects": "Projects",
      "tasks": "Tasks",
      "people": "People"
    },
    "hint_navigate": "navigate",
    "hint_open": "open",
    "hint_close": "close"
  },
  "sidebar": {
    "sections": {
      "favorites": "Favorites",
      "departments": "Teams",
      "projects": "Projects",
      "members": "Members"
    },
    "actions": {
      "new_department": "New team",
      "new_project": "New project",
      "invite_member": "Invite member",
      "view_all": "View all",
      "expand": "Expand sidebar",
      "collapse": "Collapse sidebar"
    },
    "trial": {
      "label": "Pro trial",
      "day": "day",
      "days": "days",
      "upgrade": "Upgrade →"
    }
  },
  "workspace": {
    "switch_title": "Switch workspace",
    "count_switch": "{n} workspace · switch | {n} workspaces · switch",
    "current": "Current",
    "owner_badge": "Owner",
    "member_badge": "Member",
    "create_new": "Create new workspace",
    "modal": {
      "title": "New workspace",
      "subtitle": "Create a separate space for another project, client or team. It will have its own projects, tasks and members.",
      "field_name": "Workspace name",
      "placeholder": "My new workspace",
      "cancel": "Cancel",
      "submit": "Create workspace",
      "submitting": "Creating…",
      "error_generic": "Could not create the workspace."
    }
  },
  "create_menu": {
    "trigger": "Create",
    "project": "New project",
    "task": "New task",
    "meeting": "Record meeting",
    "upload_recording": "Upload recording",
    "invite_person": "Invite person"
  },
  "user_menu": {
    "theme": "Theme",
    "theme_light": "Light",
    "theme_dark": "Dark",
    "theme_system": "System",
    "workspace_members": "Workspace members",
    "departments": "Teams",
    "settings": "Settings",
    "billing": "Plan & billing",
    "download_android": "Download Android app",
    "logout": "Sign out"
  },
  "header": {
    "record_meeting": "Record meeting"
  },
  "palette": {
    "placeholder": "Search or create a task…",
    "searching": "Searching…",
    "empty_hint": "Type something to search — or create a new task.",
    "create_task_prefix": "Create task: ",
    "ai_create_prefix": "✨ Create with AI: ",
    "ai_subtitle": "AI will detect priority, due date and assignee from the text",
    "task_in_project": "in {project}",
    "actions": {
      "go_my_tasks": "Go to My tasks",
      "go_projects": "Go to Projects",
      "go_home": "Go to Home"
    },
    "sections": {
      "create": "Create",
      "projects": "Projects",
      "tasks": "Tasks",
      "people": "People",
      "shortcuts": "Shortcuts"
    },
    "shortcuts": {
      "navigate": "navigate",
      "open": "open",
      "open_palette": "open this"
    }
  },
  "activity": "Activity"
}
